import { FileVariantType } from "db/enums"

const order: FileVariantType[] = [
  FileVariantType.SMALL_360P,
  FileVariantType.MEDIUM_720P,
  FileVariantType.LARGE_1080P,
]

const sortVariants = (variants: { type: FileVariantType }[]) =>
  variants.sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type))

export default sortVariants
